/* eslint-disable */
export default {
  title: 'Historia',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
